import { useState } from "react";
import { Box, Typography } from "@mui/material";

import {
  Apartment,
  CleaningServices,
  Construction,
  Error,
  Grass,
  House,
} from "@mui/icons-material";

type SignUpOptionProps = {
  label: string;
  icon: string;
  selected: boolean;
  onSelect: () => void;
};

const SignUpOption = ({
  label,
  icon,
  onSelect,
  selected,
}: SignUpOptionProps) => {
  const [hovered, setHovered] = useState(false);
  const getIconContent = () => {
    switch (icon) {
      case "cleaning": {
        return <CleaningServices />;
      }
      case "landscaping": {
        return <Grass />;
      }
      case "maintenance": {
        return <Construction />;
      }
      case "house": {
        return <House />;
      }
      case "apartment": {
        return <Apartment />;
      }
      default: {
        return <Error />;
      }
    }
  };
  return (
    <Box
      sx={{
        border: selected ? "3px solid #1976d2" : "1px solid",
        borderRadius: "1rem",
        height: "3rem",
        width: "50%",
        display: "flex",
        alignItems: "center",
        float: "middle",
        background: hovered || selected ? "#E6E8EA" : "#ffffff",
        cursor: hovered ? "pointer" : "default",
        justifyContent: "center",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onSelect}
    >
      {getIconContent()}
      <Typography>{label}</Typography>
    </Box>
  );
};

export default SignUpOption;
